export default {
  labels: {
    free_items: 'Free items',
  },
};